import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BookingModel } from '../../../../models/booking.model';
import { BookingService } from '../../../../services/booking.service';

@Component({
  selector: 'app-booking-success',
  templateUrl: './booking-success.component.html',
  styleUrl: './booking-success.component.scss',
  standalone: false,
})
export class BookingSuccessComponent implements OnInit {
  public isLoading = true;
  public booking: BookingModel;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private bookingService: BookingService
  ) {}

  public async ngOnInit(): Promise<void> {
    const bookingParam = this.activatedRoute.snapshot.params['bookingId'];
    if (!bookingParam) {
      this.router.navigate(['/']);
    }
    await this.getBooking(+atob(bookingParam));
    this.isLoading = false;
  }

  private async getBooking(bookingId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.bookingService.getBookingById(bookingId).subscribe(booking => {
        this.booking = booking;
        resolve();
      });
    });
  }

  public toCourseOverview() {
    this.router.navigate(['/home']);
  }
}
